export const SKU_LOCAL_STORAGE_KEY = "sku";
export const DISTRIBUTOR_LOCAL_STORAGE_KEY = "distributor";